import Kernel from "@oilstone/kernel";
import defaults from "./config";

export default (resourceType, componentType) => {
    const queryParams = Kernel.resolve('router').currentRoute.value.query;

    if (resourceType === 'pages' && queryParams.section && queryParams.section !== 'services') {
        const settings = Kernel.resolve('resourceRegistry').find(queryParams.section);

        if (settings && settings.config.components[componentType]) {
            return settings.config.components[componentType].name;
        }
    }

    const settings = Kernel.resolve('resourceRegistry').find(resourceType);
    const component = settings.config.components[componentType] || defaults.components[componentType];

    return component.name;
}
